// Google Analytics 4 — privacy-friendly pageview + event tracking via gtag.js.
//
// Only fires on the production host (nomadlife.top) so the preview environment
// and local development don't pollute analytics.

const GA4_MEASUREMENT_ID = "G-VV15YM4EK4";
const GA4_SRC = `https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`;
const PROD_HOSTS = new Set(["nomadlife.top", "www.nomadlife.top"]);

let installed = false;

function isProdHost() {
  if (typeof window === "undefined") return false;
  return PROD_HOSTS.has(window.location.hostname);
}

export function installAnalytics() {
  if (installed) return;
  if (!isProdHost()) return;
  if (document.querySelector(`script[src="${GA4_SRC}"]`)) {
    installed = true;
    return;
  }
  // Initialise the data layer before the external script loads so any early
  // events queued by trackEvent() still reach GA once gtag.js boots.
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA4_MEASUREMENT_ID, { send_page_view: true });

  const s = document.createElement("script");
  s.async = true;
  s.src = GA4_SRC;
  document.head.appendChild(s);
  installed = true;
}

/**
 * Fire a custom GA4 event. Safe no-op when gtag is not loaded
 * (e.g. preview / local dev) so analytics can never break the app.
 *
 * @param {string} name  Short event name, e.g. "signup_completed"
 * @param {object} [data] Optional event parameters (string/number values only)
 */
export function trackEvent(name, data) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    if (data && Object.keys(data).length > 0) {
      window.gtag("event", name, data);
    } else {
      window.gtag("event", name);
    }
  } catch {
    // analytics must never break the app
  }
}
